import { render } from "./code-change.vue?vue&type=template&id=53a85e20&scoped=true&ts=true"
import script from "./code-change.vue?vue&type=script&lang=ts"
export * from "./code-change.vue?vue&type=script&lang=ts"

import "./code-change.vue?vue&type=style&index=0&id=53a85e20&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53a85e20"]])

export default __exports__